import { ObjectModel } from './../../../../../models/ObjectModel';
import { Component, inject, Input, OnInit } from '@angular/core';
import { ConverterService } from "../../../../../services/converter.service";
import { AccessRights, UsersService } from "../../../../../services/users.service";
import { LocalizeMetersPipe } from 'app/system/shared/pipes/Converter.pipe';


@Component({
  selector: 'app-object-green-driving',
  standalone: false,
  templateUrl: './object-green-driving.component.html',
  styleUrl: './object-green-driving.component.css',
})
export class ObjectGreenDrivingComponent implements OnInit {

  @Input()
  public Object: ObjectModel;


  public canEditTrackers: boolean = false;

  private usersService = inject(UsersService);
  constructor(private converterService: ConverterService) { }

  public maxSpeedVisited = false;
  public dangerousSpeedVisited = false;

  public harshAccVisited = false;
  public dangerousAccVisited = false;

  public harshBrVisited = false;
  public dangerousBrVisited = false;

  public harshTurnVisited = false;
  public dangerousTurnVisited = false;

  ngOnInit() {
    this.canEditTrackers =
      this.usersService.getCurrentUser().CanDo(AccessRights.EDIT_TRACKERS);

    // Force error visibility if already invalid (on load)
    this.maxSpeedVisited = this.isMaxSpeedInvalid();
    this.dangerousSpeedVisited = this.isDangerousSpeedInvalid();

    this.harshAccVisited = this.isHarshAccInvalid();
    this.dangerousAccVisited = this.isDangerousAccInvalid();

    this.harshBrVisited = this.isHarshBrInvalid();
    this.dangerousBrVisited = this.isDangerousBrInvalid();

    this.harshTurnVisited = this.isHarshTurnInvalid();
    this.dangerousTurnVisited = this.isDangerousTurnInvalid();
  }

  private isInvalid(
    lower: number | null | undefined,
    higher: number | null | undefined
  ): boolean {
    if (lower == null || higher == null) {
      return false;
    }

    return lower > higher;
  }

  private isMaxSpeedInvalid(): boolean {
    return this.isInvalid(this.Object.MaxSpeed, this.Object.DangerousSpeed);
  }

  private isDangerousSpeedInvalid(): boolean {
    return this.isInvalid(this.Object.MaxSpeed, this.Object.DangerousSpeed);
  }

  private isHarshAccInvalid(): boolean {
    return this.isInvalid(this.Object.HarshAcceleration, this.Object.DangerousAcceleration);
  }

  private isDangerousAccInvalid(): boolean {
    return this.isInvalid(this.Object.HarshAcceleration, this.Object.DangerousAcceleration);
  }

  private isHarshBrInvalid(): boolean {
    return this.isInvalid(this.Object.HarshBreaking, this.Object.DangerousBreaking);
  }

  private isDangerousBrInvalid(): boolean {
    return this.isInvalid(this.Object.HarshBreaking, this.Object.DangerousBreaking);
  }

  private isHarshTurnInvalid(): boolean {
    return this.isInvalid(this.Object.HarshTurn, this.Object.DangerousTurn);
  }

  private isDangerousTurnInvalid(): boolean {
    return this.isInvalid(this.Object.HarshTurn, this.Object.DangerousTurn);
  }

  public convertMaxSpeed(value: number) {
    this.Object.MaxSpeed = this.converterService.ParseSpeed(value);
  }

  public convertDangerousSpeed(value: number) {
    this.Object.DangerousSpeed = this.converterService.ParseSpeed(value);
  }

  public convertHarshAcceleration(value: number) {
    this.Object.HarshAcceleration = value;
  }

  public convertDangerousAcceleration(value: number) {
    this.Object.DangerousAcceleration = value;
  }

  public convertHarshBreaking(value: number) {
    this.Object.HarshBreaking = value;
  }

  public convertDangerousBreaking(value: number) {
    this.Object.DangerousBreaking = value;
  }

  public convertHarshTurn(value: number) {
    this.Object.HarshTurn = value;
  }

  public convertDangerousTurn(value: number) {
    this.Object.DangerousTurn = value;
  }

  getMin(harsh?: number | null): number | null {
    return harsh;
  }

  getMax(dangerous?: number | null): number | null {
    return dangerous;
  }
  // private toLocalized(value: number | null | undefined): number | null {
  //   if (value == null) return null;
  //   return this.localizeMetersPipe.transform(value);
  // }
}
